



























































import Vue from 'vue';
import Component from 'vue-class-component';
import ProfileProgressbar from '@/components/profile-progressbar.vue';
import { UserBadge, UserProgressTarget } from '@/models/profile';
import ProfileBadge from '@/components/profile-badge.vue';
import ProgressCalculator from '@/services/progress-calculator';
import { Community } from '@/constants';

@Component({
    components: { ProfileBadge, ProfileProgressbar },
})

export default class ProfilePage extends Vue {
    private userProgressTargets: UserProgressTarget[] = [];

    private progress: ProgressCalculator = null;

    private sheetPageContent: Vue;
    private sheetOpened: boolean = false;
    private sheetUserBadge: UserBadge = new UserBadge();

    public mounted() {
        this.progress = new ProgressCalculator(this.$store);
        this.sheetPageContent = this.$refs.sheetPageContent as Vue;

        this.initProgress();
        this.refresh();
    }

    public onDisappearing() {
        this.sheetOpened = false;
    }

    private initProgress() {
        this.userProgressTargets = [
            new UserProgressTarget(this.$t('profile.unlocked_communities'), 0, 11),
            new UserProgressTarget(this.$t('profile.unlocked_routes'), 0, 12),
            new UserProgressTarget(this.$t('profile.unlocked_pois'), 0, 147),
        ];
    }

    public async refresh() {
        await this.$store.waitUntilReady();

        this.progress.updateBadges();

        this.userProgressTargets = [
            new UserProgressTarget(this.$t('profile.unlocked_communities'),
                this.progress.completedCommunityCount, this.progress.communityCount),
            new UserProgressTarget(this.$t('profile.unlocked_routes'),
                this.progress.completedRouteCount, this.$store.routes.length),
            new UserProgressTarget(this.$t('profile.unlocked_pois'),
                this.progress.unlockedPoiCount, this.$store.pois.length),
        ];
    }

    private sheetClicked() {
        this.sheetOpened = !this.sheetOpened;
    }

    private showBadge(badge: UserBadge) {
        this.sheetUserBadge = badge;
        this.sheetOpened = !this.sheetOpened;
    }
}
